// extracted by mini-css-extract-plugin
module.exports = {"container":"_8wNfacotIxNeoF4JPry5I","messageWrapper":"_2-tB9PQnYi_F_Ultrljd3w","message":"_2Ch1kDdj3gUff3O7h4BYlK"};